const SingleYNCheckbox = ({
    fieldId,
    label,
    checkedValue,
    setCheckedValue
}) => {
    return (
        <div className="mt-2">
            <label className="checkbox-label flex items-center gap-2">
                {label}
                <input
                    type="checkbox"
                    id={`field-${fieldId}`}
                    className="checkbox-accent"
                    checked={checkedValue === "Y"}
                    onChange={(e) => {
                        const value = e.target.checked ? "Y" : "N";
                        setCheckedValue(value);
                    }}
                />
                
            </label>
        </div>
    );
};

export default SingleYNCheckbox;